import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box,
  Flex,
} from '@chakra-ui/react';
import Topic from './Topic';

interface Props {
  topics: any[];
}
const Section: React.FC<Props> = ({ topics }: Props) => {
  return (
    <Flex
      direction="column"
      p={[0, 6]}
      bgColor="gray.800"
      color="white"
      roundedRight={{ md: 8 }}
      width="100%"
    >
      <Accordion allowToggle>
        {topics.length > 0 &&
          topics.map((topic, index) => (
            <AccordionItem borderColor="gray.600" key={index}>
              <h2>
                <AccordionButton _expanded={{ fontWeight: 'bold' }}>
                  <Box flex="1" textAlign="left">
                    {topic.title}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <Topic topic={topic}>test</Topic>
            </AccordionItem>
          ))}
      </Accordion>
    </Flex>
  );
};

export default Section;
